<template>
  <ed-input-item :label="label" :info="info" :name="name" :required="required">
  <div class="">
    <div class="">
      <b-form-file
        v-model="value"
        :ref="'file-input-' + this.name"
        :disabled="disabled"
        :accept="accept"
        :multiple="multiple"
        @change="onChangeFile"
        placeholder="Escolher arquivo..."
        drop-placeholder="Apagar arquivo..."
        browse-text="Procurar..."
      >
        <template slot="file-name" slot-scope="{ names }">
          <b-badge variant="dark">{{ names[0] }}</b-badge>
          <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
            + {{ names.length - 1 }} More files
          </b-badge>
        </template>
      </b-form-file>
    </div>

    <div class="arquivo-info" v-if="currentFile != null">
      <Download :arquivo="currentFile" />
    </div>
  </div>
 </ed-input-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import Download from 'common/download';
import EdInputItem from "./EdInputItem";

export default {
  name: "EdInputUpload",
  mixins: [EdFormMixin],
  components:{Download,EdInputItem},
  props: {
    extensoes: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    isBase: {
      type: Boolean,
      required: false,
      default: false,
    },
    accept: {
      type: String,
      default: function () {
        return "";
      },
    },
    currentFile: {
      type: [Object, Array, File],
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {
    getAccept() {
      let arrayExtensoes = [];

      let extensoes = {
        doc: ["application/msword"],
        jpg: ["image/jpeg"],
        text: ["text/plain"],
        svg: ["image/svg+xml"],
        xls: [
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ],
        pfx: ["application/x-pkcs12"],
        crt: ["application/pkix-cert"],
      };

      this.extensoes.forEach((value) => {
        if (extensoes[value]) {
          arrayExtensoes.push(extensoes[value].join(","));
        }
      });

      return arrayExtensoes.join(",");
    },
  },
  methods: {
    onChangeFile(e) {

      e.preventDefault();
      let file =  e.target.files[0]

      this.$emit("input", file);
      this.$emit("change", file);
    },

    clearFiles() {
      this.$refs["file-input-" + this.input].reset();
    },

    handleChange(e) {
      if (this.onChangeFile) this.onChangeFile(e);

      e.preventDefault();

      this.$events.fire("upload-" + this.input, e.target.files[0]);
      //this.$events.fire('upload-'+this.input,e.target.files);
    },
  },

  watch: {
    accept() {},
    extensoes() {},
  },
};
</script>



// WEBPACK FOOTER //
// EdInputUpload.vue?58093aac